import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import {
    IdentityProviderConfiguration
} from "@idw-types/data/identity-providers";
import { handleRequest } from "@utils/http-util";

type GetIdentityProviderConfigurationsResponse = {
    identityProviderConfigs: Array<IdentityProviderConfiguration>;
};

export const getIdentityProviderConfigurationsRequest = async (): Promise<{ data: GetIdentityProviderConfigurationsResponse, error: any }> => {
    const route = apiRoutes.idpConfiguration.identityProviderConfig.identityProviders;
    const { data, error } = await handleRequest(RequestTypes.GET, route);
    return { data, error };
};
